module.exports = __webpack_public_path__ + "static/img/qm_quit_confirm.67073f93.png";